<div>
  @if (showHeader) {
    <div class="d-flex mb-4 flex-column align-items-start flex-lg-row align-items-lg-end mt-2">
      <h4 class="me-2 mb-0">{{ 'orderProcess.payment.contactForm.title' | translate }}</h4>

      <div class="text-primary cursor-pointer font-md d-none d-sm-block"
           [translate]="'orderProcess.payment.whyDoAskInfo.question'"
           [ngbTooltip]="'orderProcess.payment.whyDoAskInfo.answer' | translate">
      </div>
    </div>
  }

  <div>
    <payment-contact-info
      [countryCode]="countryCode"
      [personType]="privatePaymentType"
      [askForReferenceField]="false"
      [userInfo]="contactInfo"
      (onValidUpdated)="onContactInfoValidated($event)"
      (onInfoUpdated)="onContactInfoUpdated($event); errorMsg=''"
    ></payment-contact-info>

    <div class="d-flex justify-content-end">
      <button class="btn btn-pink mt-3"
              *ngIf="!isContactInfoSubmitted"
              (click)="continueInvoice()"
              [disabled]="!isContactInfoFilled"
              [translate]="'common.continue'">
        Continue
      </button>
    </div>
  </div>

  <div [hidden]="!isContactInfoSubmitted">
    <div class="d-flex mt-5 mb-4 flex-column align-items-start flex-lg-row align-items-lg-end mt-2">
      <h4 class="me-2 mb-0">{{ 'orderProcess.payment.invoice.title' | translate }}</h4>
    </div>

    <user-invoice-info
      [countryCode]="countryCode"
      [paymentInfo]="contactInfo"
      [isForPayment]="true"
      [invoiceInfo]="invoiceInfo"
      [user]="user"
      [bakeryId]="bakeryId"
      [isSharedBusinessAccount]="isSharedBusinessAccount"
      [allowToChangeCountry]="allowToChangeCountry"
      [showInvoiceFormat]="showInvoiceFormat"
      [companyChangeActions]="companyChangeActions"
      [(isValid)]="isInvoiceInfoValid"
      (onInvoiceUpdated)="onUpdated($event); errorMsg=''"
      (onChangeCompanyClick)="errorMsg=''"
    ></user-invoice-info>
  </div>

  @if (isContactInfoSubmitted) {
    <div class="pt-1">
      @if (!alreadySubscriber) {
        <ui-newsletter-signup
          class="d-block mt-2 mb-3"
          [isSubscribe]="contactInfo?.subscribedOnNews"
          (onChange)="newsletterUpdate($event)"
        ></ui-newsletter-signup>
      }

      @if (errorMsg) {
        <ui-message class="d-block my-4"
                    [type]="'error'">
          {{ errorMsg }}
        </ui-message>
      }

      <div>
        <button class="btn btn-pink btn-xl mb-4"
                [disabled]="!isInvoiceInfoValid || !isContactInfoFilled"
                (click)="createInvoiceOrder(invoiceInfo, contactInfo)">
          {{ 'common.confirm' | translate }}
        </button>

        <terms-and-conditions (onTermsClick)="onTermsClick.emit()">
        </terms-and-conditions>

        <ng-content></ng-content>
      </div>
    </div>
  }

</div>
